import React from 'react';
export const TermsOfService = () => {
  return <main className="w-full bg-white py-16" data-id="element-434">
      <div className="container mx-auto px-4" data-id="element-435">
        <h1 className="text-4xl font-bold mb-8 text-center" data-id="element-436">
          Terms of Service
        </h1>
        <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-100" data-id="element-437">
          <p className="text-gray-500 mb-8 text-sm" data-id="element-438">
            Last updated: January 1, 2023
          </p>
          <section className="mb-10" data-id="element-439">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-440">1. Introduction</h2>
            <p className="text-gray-700 mb-4" data-id="element-441">
              Welcome to Binary Solutions 101010 ("Company", "we", "our", "us")!
              As you have just clicked our Terms of Service, please pause, grab
              a cup of coffee and carefully read the following pages. It will
              take you approximately 20 minutes.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-442">
              These Terms of Service ("Terms", "Terms of Service") govern your
              use of our website located at binarysolutions101010.com (together
              or individually "Service") operated by Binary Solutions 101010.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-443">
              Our Privacy Policy also governs your use of our Service and
              explains how we collect, safeguard and disclose information that
              results from your use of our web pages. Please read it here.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-444">
              Your agreement with us includes these Terms and our Privacy Policy
              ("Agreements"). You acknowledge that you have read and understood
              Agreements, and agree to be bound by them.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-445">
              If you do not agree with (or cannot comply with) Agreements, then
              you may not use the Service, but please let us know by emailing at
              support@binarysolutions101010.com so we can try to find a
              solution. These Terms apply to all visitors, users and others who
              wish to access or use Service.
            </p>
          </section>
          <section className="mb-10" data-id="element-446">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-447">2. Communications</h2>
            <p className="text-gray-700 mb-4" data-id="element-448">
              By using our Service, you agree to subscribe to newsletters,
              marketing or promotional materials and other information we may
              send. However, you may opt out of receiving any, or all, of these
              communications from us by following the unsubscribe link or by
              emailing at support@binarysolutions101010.com.
            </p>
          </section>
          <section className="mb-10" data-id="element-449">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-450">3. Purchases</h2>
            <p className="text-gray-700 mb-4" data-id="element-451">
              If you wish to purchase any product or service made available
              through Service ("Purchase"), you may be asked to supply certain
              information relevant to your Purchase including, without
              limitation, your credit card number, the expiration date of your
              credit card, your billing address, and your shipping information.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-452">
              You represent and warrant that: (i) you have the legal right to
              use any credit card(s) or other payment method(s) in connection
              with any Purchase; and that (ii) the information you supply to us
              is true, correct and complete.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-453">
              We reserve the right to refuse or cancel your order at any time
              for reasons including but not limited to: product or service
              availability, errors in the description or price of the product or
              service, error in your order or other reasons.
            </p>
          </section>
          <section className="mb-10" data-id="element-454">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-455">4. Subscriptions</h2>
            <p className="text-gray-700 mb-4" data-id="element-456">
              Some parts of Service are billed on a subscription basis
              ("Subscription(s)"). You will be billed in advance on a recurring
              and periodic basis ("Billing Cycle"). Billing cycles are set
              either on a monthly or annual basis, depending on the type of
              subscription plan you select when purchasing a Subscription.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-457">
              At the end of each Billing Cycle, your Subscription will
              automatically renew under the exact same conditions unless you
              cancel it or Binary Solutions 101010 cancels it. You may cancel
              your Subscription renewal either through your online account
              management page or by contacting Binary Solutions 101010 customer
              support team.
            </p>
          </section>
          <section className="mb-10" data-id="element-458">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-459">
              5. Intellectual Property
            </h2>
            <p className="text-gray-700 mb-4" data-id="element-460">
              Service and its original content (excluding Content provided by
              users), features and functionality are and will remain the
              exclusive property of Binary Solutions 101010 and its licensors.
              Service is protected by copyright, trademark, and other laws of
              both the United States and foreign countries. Our trademarks and
              trade dress may not be used in connection with any product or
              service without the prior written consent of Binary Solutions
              101010.
            </p>
          </section>
          <section className="mb-10" data-id="element-461">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-462">6. Termination</h2>
            <p className="text-gray-700 mb-4" data-id="element-463">
              We may terminate or suspend your account and bar access to Service
              immediately, without prior notice or liability, under our sole
              discretion, for any reason whatsoever and without limitation,
              including but not limited to a breach of Terms.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-464">
              If you wish to terminate your account, you may simply discontinue
              using Service.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-465">
              All provisions of Terms which by their nature should survive
              termination shall survive termination, including, without
              limitation, ownership provisions, warranty disclaimers, indemnity
              and limitations of liability.
            </p>
          </section>
          <section className="mb-10" data-id="element-466">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-467">7. Governing Law</h2>
            <p className="text-gray-700 mb-4" data-id="element-468">
              These Terms shall be governed and construed in accordance with the
              laws of the State of California without regard to its conflict of
              law provisions.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-469">
              Our failure to enforce any right or provision of these Terms will
              not be considered a waiver of those rights. If any provision of
              these Terms is held to be invalid or unenforceable by a court, the
              remaining provisions of these Terms will remain in effect. These
              Terms constitute the entire agreement between us regarding our
              Service and supersede and replace any prior agreements we might
              have had between us regarding Service.
            </p>
          </section>
          <section data-id="element-470">
            <h2 className="text-2xl font-semibold mb-4" data-id="element-471">8. Contact Us</h2>
            <p className="text-gray-700 mb-4" data-id="element-472">
              If you have any questions about these Terms, please contact us:
            </p>
            <ul className="list-disc pl-8 mb-4 text-gray-700" data-id="element-473">
              <li data-id="element-474">Email: am@binary-solutions.co.za</li>
              <li data-id="element-475">Phone: + 27 677 834 937</li>
              <li data-id="element-476">
                Address: 296 francis baard street office 0314, pretoria cbd,
                gauteng, 0002
              </li>
            </ul>
          </section>
        </div>
      </div>
    </main>;
};